const initVerifyContact = () => {
    const prenomField = document.getElementById('contact_prenom');
    const nomField = document.getElementById('contact_nom');
    const emailField = document.getElementById('contact_email');
    const messageContainer = document.getElementById('contact-message-container');
    const entrepriseForm = document.querySelector('#new_entreprise');

    if (!prenomField && !nomField && !emailField && !entrepriseForm && !messageContainer) return;

    const junior = document.querySelector('[data-junior-id]')?.dataset.juniorId || '<%= @junior.id %>';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const checkEmailFormat = (email) => emailRegex.test(email);

    const checkUniqueness = () => {
        if (!prenomField || !nomField || !emailField || !messageContainer) return;

        const prenom = prenomField.value;
        const nom = nomField.value;
        const email = emailField.value;

        const oldErrorMessage = document.getElementById('email-error-message');
        if (oldErrorMessage) oldErrorMessage.remove();

        fetch(`/juniors/${junior}/contacts/verify?prenom=${prenom}&nom=${nom}&email=${email}`)
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then((data) => {
                messageContainer.innerHTML = '';
                if (data.email_exists || data.nom_prenom_exists) {
                    const message = 'Un contact a été trouvé avec les mêmes informations.';
                    const button = `<a href="/juniors/${junior}/contacts/${data.contact}" class="btn btn-info">Voir le contact</a>`;
                    messageContainer.innerHTML = `<div>${message}</div>${button}`;
                }
            })
            .catch((error) => console.error('Error fetching data:', error));

        if (!checkEmailFormat(email) && email.trim() !== '') {
            const errorMessage = document.createElement('div');
            errorMessage.id = 'email-error-message';
            errorMessage.textContent = "L'adresse e-mail n'est pas valide.";
            errorMessage.className = 'email-error';
            emailField.parentNode.insertBefore(errorMessage, emailField.nextSibling);
        }
    };

    if (entrepriseForm) {
        entrepriseForm.addEventListener('ajax:success', (event) => {
            const [data] = event.detail;
            const entrepriseSelect = document.querySelector('#contact_entreprise_id');
            if (!entrepriseSelect) return;
            const newOption = new Option(data.nom, data.id, true, true);
            entrepriseSelect.add(newOption);
            document.getElementById('bottom-panel')?.classList.remove('active');
            document.getElementById('overlay2')?.classList.remove('active');
        });
    }

    if (prenomField) prenomField.addEventListener('blur', checkUniqueness);
    if (nomField) nomField.addEventListener('blur', checkUniqueness);
    if (emailField) emailField.addEventListener('blur', checkUniqueness);

};

export { initVerifyContact };
